const actionTypeIdentifier = 'BF4A811D-06FD-4B8B-A769-9D95C16F6EE6'; //action identifier should be unique

export const setLanguage = `SET_LANGUAGE-${actionTypeIdentifier}`;
export const setLangConfodalOpen = `SET_LANGUAGE_CONFIRM_MODAL_OPEN-${actionTypeIdentifier}`;
export const getToolLanguages = `GET_TOOL_LANGUAGES-${actionTypeIdentifier}`;
export const setLanguageLoading = `SET_LANGUAGE_IS_LOADING-${actionTypeIdentifier}`;
export const setAuthedUser = `SET_AUTHED_USER-${actionTypeIdentifier}`;